import { BrowserRouter, Routes, Route, NavLink, useLocation } from 'react-router-dom';
import './App.css';

function Page({ title, children }) {
  const { pathname } = useLocation();
  return (
    <main className="Page">
      <h1>{title}</h1>
      <p className="Page-path">
        Current route: <code>{pathname}</code>
      </p>
      {children}
    </main>
  );
}

function Home() {
  return (
    <Page title="Home">
      <p>Welcome to the Azure Static Web Apps navigation test site.</p>
      <p>Use the links above to move between pages, then try refreshing the browser on each route.</p>
    </Page>
  );
}

function About() {
  return (
    <Page title="About">
      <p>This is a small React app built with Create React App and React Router.</p>
      <p>It exists to verify client-side routing works after deployment to Azure Static Web Apps.</p>
    </Page>
  );
}

function Contact() {
  return (
    <Page title="Contact">
      <p>Questions? Reach out at <a href="mailto:hello@example.com">hello@example.com</a>.</p>
    </Page>
  );
}

function NotFound() {
  return (
    <Page title="404 - Not Found">
      <p>That page does not exist.</p>
    </Page>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <header className="App-header">
          <span className="App-brand">SWA Nav Test</span>
          <nav className="App-nav">
            <NavLink to="/" end>Home</NavLink>
            <NavLink to="/about">About</NavLink>
            <NavLink to="/contact">Contact</NavLink>
          </nav>
        </header>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
